import React, { useState, useCallback } from "react";
import wl_logo_expanded from "../static/images/WL_banner.png";
import "../sass/main.scss";
import { useNavigate } from "react-router-dom";

export const NavMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  const onWanderLogoClick = useCallback(() => {
    setIsOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate("/");
  }, [navigate]);

  const links = [
    { label: "DESTINATIONS", path: "/", subLinks: ["India", "Bhutan", "Sri Lanka"] },
    { label: "ABOUT US", path: "/about" },
    { label: "ENQUIRE NOW", path: "/contact" },
  ];

  return (
    <div className="nav-container">
      <div className={`menu-toggle ${isOpen ? "open" : ""}`} onClick={toggleMenu}>
        {isOpen ? <span className="close">&times;</span> : <span className="hamburger">&#9776;</span>}
      </div>

      <nav className={`nav-overlay ${isOpen ? "show" : ""}`}>
        <div className="nav-content">
          <div className="nav-left">
            <img
              style={{ cursor: "pointer" }}
              src={wl_logo_expanded}
              onClick={onWanderLogoClick}
              alt="WanderLuxe"
            />
            <div className="nav-links">
              {links.map(({ label, path, subLinks }) => (
                <div key={label} className={`nav-item ${subLinks ? "has-sublinks" : ""}`}>
                  <p>
                    <a href={path}>{label}</a>
                  </p>
                  {subLinks && (
                    <div className="sublinks">
                      {subLinks.map((sub) => (
                        <a
                          key={sub}
                          href={`/:${sub.replace(/\s+/g, '')}`}
                        >
                          {sub}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};
